<template>
  <section class="section bg">
    <div class="container">
      <h1 class="title is-4 has-text-grey-lighter">Book a Trial on Whatsapp</h1>
      <h2 class="subtitle has-text-grey">
        Ask a professional MMA trainer about your MMA regime, personally!
      </h2>
      <Whatsapp class="is-size-6" :title="`Ask a Professional`" />
    </div>
  </section>
</template>

<script>
import Whatsapp from "./Whatsapp.vue";
export default {
  components: {
    Whatsapp
  }
};
</script>

<style lang="scss" scoped>
.bg {
  //background-image: url("../assets/join-knockout-fight-club.jpg") !important;
  background-repeat: no-repeat;
  background-position: right;
  background-color: rgb(18, 18, 18);
  background-size: contain;
  // bg size 212 X 636 px
}
</style>
